(() => {
  const SELECTOR_SECTION = '.shopify-section';
  const SELECTOR_VARIANTS = 'script[data-variants-json]';
  const SELECTOR_MONEY_WITH_CURRENCY = 'script[data-money-with-currency-format]';
  const SELECTOR_FORM = 'product-form form, form[action*="/cart/add"], form[action$="/cart/add"]';
  const SELECTOR_ID_INPUT = 'input[name="id"]';
  const SELECTOR_ATC_PRICE = '[data-atc-price]';

  function parseJsonScript(el) {
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch {
      return null;
    }
  }

  // --- Shopify-like money formatting (no dependency on Shopify.formatMoney) ---
  function formatWithDelimiters(number, precision, thousands, decimal) {
    if (isNaN(number) || number === null) return '0';

    const fixed = (number / 100).toFixed(precision);
    const parts = fixed.split('.');
    const dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, `$1${thousands}`);
    const cents = parts[1] ? decimal + parts[1] : '';
    return dollars + cents;
  }

  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    const value = Number(cents);
    if (!isFinite(value)) return '';

    // Find the placeholder, e.g. {{ amount_with_comma_separator }}
    const match = format.match(
      /\{\{\s*(amount|amount_no_decimals|amount_with_comma_separator|amount_no_decimals_with_comma_separator|amount_with_space_separator|amount_no_decimals_with_space_separator|amount_with_apostrophe_separator)\s*\}\}/
    );

    if (!match) {
      // If format doesn't contain a known placeholder, return a basic value
      return String((value / 100).toFixed(2));
    }

    const placeholder = match[1];
    let formattedValue = '';

    switch (placeholder) {
      case 'amount':
        formattedValue = formatWithDelimiters(value, 2, ',', '.');
        break;

      case 'amount_no_decimals':
        formattedValue = formatWithDelimiters(value, 0, ',', '.');
        break;

      case 'amount_with_comma_separator':
        formattedValue = formatWithDelimiters(value, 2, '.', ',');
        break;

      case 'amount_no_decimals_with_comma_separator':
        formattedValue = formatWithDelimiters(value, 0, '.', ',');
        break;

      case 'amount_with_space_separator':
        formattedValue = formatWithDelimiters(value, 2, ' ', ',');
        break;

      case 'amount_no_decimals_with_space_separator':
        formattedValue = formatWithDelimiters(value, 0, ' ', ',');
        break;

      case 'amount_with_apostrophe_separator':
        formattedValue = formatWithDelimiters(value, 2, "'", '.');
        break;

      default:
        formattedValue = formatWithDelimiters(value, 2, ',', '.');
    }

    return format.replace(match[0], formattedValue);
  }

  function findVariant(variants, variantId) {
    const idNum = Number(variantId);
    return variants.find((v) => Number(v.id) === idNum) || null;
  }

  function updateAtcPrice(section) {
    const variants = parseJsonScript(section.querySelector(SELECTOR_VARIANTS));
    const moneyWithCurrencyFormat = parseJsonScript(section.querySelector(SELECTOR_MONEY_WITH_CURRENCY));

    if (!variants || !Array.isArray(variants)) return;
    if (!moneyWithCurrencyFormat) return;

    const form = section.querySelector(SELECTOR_FORM);
    if (!form) return;

    const idInput = form.querySelector(SELECTOR_ID_INPUT);
    if (!idInput || !idInput.value) return;

    const variant = findVariant(variants, idInput.value);
    if (!variant) return;

    const priceText = formatMoney(variant.price, moneyWithCurrencyFormat);

    section.querySelectorAll(SELECTOR_ATC_PRICE).forEach((el) => {
      // Reads as: "Add to cart €49,90 EUR"
      el.textContent = priceText ? ` ${priceText}` : '';
    });
  }

  function initSection(section) {
    const hasData =
      section.querySelector(SELECTOR_VARIANTS) &&
      section.querySelector(SELECTOR_MONEY_WITH_CURRENCY) &&
      section.querySelector(SELECTOR_FORM);

    if (!hasData) return;

    updateAtcPrice(section);

    // Variant changes
    section.addEventListener('change', (e) => {
      if (e.target.closest('variant-selects, variant-radios, [name="id"], .product-form__input')) {
        requestAnimationFrame(() => updateAtcPrice(section));
        setTimeout(() => updateAtcPrice(section), 80);
      }
    });

    // If your theme fires these, great; if not, harmless
    section.addEventListener('variant:change', () => updateAtcPrice(section));
    section.addEventListener('variant-change', () => updateAtcPrice(section));
  }

  function boot() {
    document.querySelectorAll(SELECTOR_SECTION).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
